import { render, staticRenderFns } from "./new-registered-judge.vue?vue&type=template&id=7c8e069a&scoped=true&"
import script from "./new-registered-judge.vue?vue&type=script&lang=js&"
export * from "./new-registered-judge.vue?vue&type=script&lang=js&"
import style0 from "./new-registered-judge.vue?vue&type=style&index=0&id=7c8e069a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e069a",
  null
  
)

export default component.exports